import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Overlay from '../../forms/_common/Overlay';
import RequestError from '../../forms/_common/RequestError';
import DialogTemplate from '../../dialogs_common/DialogTemplate';
import FormTemplate from '../../dialogs_common/FormTemplate';
import Loader from '../../components/Loader';
import { useQueryMutation } from '../../../hooks/@lore/query-connect';

Step2.propTypes = {
  data: PropTypes.object.isRequired,
  onNext: PropTypes.func.isRequired
};

export default function Step2(props) {
  const {
    data: _data,
    onNext,
    onCancel
  } = props;

  const {
    offer,
    uploads
  } = _data;

  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(null);

  const mutation = useQueryMutation('upload.create');

  useEffect(function() {
    if (uploads.data.length === 0) {
      return onNext();
    }

    async function copy() {
      const mutations = uploads.data.map(function(upload) {
        return mutation.mutateAsync({
          offerId: offer.id,
          name: upload.data.name,
          description: upload.data.description,
          url: upload.data.url
        });
      });

      setSaving(true);

      try {
        await Promise.all(mutations);
      } catch (error) {
        setError(error);
      }

      setSaving(false);
      onNext();
    }

    copy();
  }, []);

  return (
    <DialogTemplate>
      <Overlay isVisible={saving}>
        <FormTemplate
          title="Duplicating Offer"
          subtitle={(
            <span>
              Copying upload information...
            </span>
          )}
          onClose={onCancel}
          alert={error ? (
            <RequestError request={error} />
          ) : null}
          body={saving && (
            <div className="flex pb-12">
              <Loader />
            </div>
          )}
        />
      </Overlay>
    </DialogTemplate>
  );
};
